<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <!-- 面談日期 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">面談日期</label>
              <ValidationProvider
                :rules="{ dateRangeRequired: true }"
                v-slot="{ errors }"
              >
                <el-date-picker
                  class="w-100"
                  type="daterange"
                  clearable
                  :picker-options="{
                    disabledDate: $common.disabledDateAfterToday,
                  }"
                  range-separator="-"
                  start-placeholder="開始日期"
                  end-placeholder="結束日期"
                  v-model="interviewDateRange"
                />
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <!-- 單位面試主管 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">單位面試主管</label>
              <el-select
                class="w-100"
                filterable
                clearable
                placeholder="請選擇"
                v-model="searchCondition.InterviewSupervisor"
              >
                <el-option
                  v-for="supervisor in supervisorOptions"
                  :key="supervisor.Guid"
                  :label="supervisor.Name"
                  :value="supervisor.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- HR 面試人員 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">HR 面試人員</label>
              <el-select
                class="w-100"
                filterable
                clearable
                placeholder="請選擇"
                v-model="searchCondition.InterviewHR"
              >
                <el-option
                  v-for="supervisor in supervisorOptions"
                  :key="supervisor.Guid"
                  :label="supervisor.Name"
                  :value="supervisor.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for=""> 職缺編號 </label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model.trim="searchCondition.manpowerDemandNo"
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">職缺名稱</label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model.trim="searchCondition.manpowerDemandName"
              />
            </div>
          </div>

          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">{{ i18n("Basic.Candidate") }}</label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model.trim="searchCondition.interviewee"
              />
            </div>
          </div>

          <div class="col-sm-12 col-md-3">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px"
              @click="
                (currentPage = 1),
                  getAppointmentResult()
              "
            >
              {{ i18n("Buttons.Search") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <CardStyle @changeStyle="changeStyle" />
    </div>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard ref="personCard" :showCheckbox="false" :person="person">
          <template v-slot:tag="{ props }">
            <div class="result">{{ props.ApprovalResult }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table class="appoint-result-table">
              <tr style="height: 60px">
                <th>職缺名稱</th>
                <td>{{ props.ManpowerDemandName }}</td>
              </tr>
              <tr>
                <th>單位面試主管</th>
                <td>{{ props.InterviewSupervisor[0] }}</td>
              </tr>
              <tr>
                <th>HR 面試人員</th>
                <td>{{ props.InterviewHR[0] }}</td>
              </tr>
              <tr>
                <th>任用部門</th>
                <td>{{ props.AppointmentDepartment }}</td>
              </tr>
              <tr style="height: 60px">
                <th>任用職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>簽核者</th>
                <td>
                  {{ props.Approver }}
                </td>
              </tr>
              <tr>
                <th>通知錄取</th>
                <td>
                  {{
                    props.HireNoticeMailTime
                      ? $common.dateTimeFormatter(props.HireNoticeMailTime)
                      : "尚未"
                  }}
                </td>
              </tr>
              <tr>
                <th>通知報到</th>
                <td>
                  {{
                    props.ReportNoticeMailTime
                      ? $common.dateTimeFormatter(props.ReportNoticeMailTime)
                      : "尚未"
                  }}
                </td>
              </tr>
              <tr>
                <th>報到意願</th>
                <td>
                  <el-tooltip
                    v-if="props.OnBoardIntentionReason"
                    class="item"
                    effect="dark"
                    :content="props.OnBoardIntentionReason"
                    placement="right"
                  >
                    <span>
                      {{ props.OnBoardIntention }}
                    </span>
                  </el-tooltip>
                  <template v-else>
                    {{ props.OnBoardIntention }}
                  </template>
                </td>
              </tr>
              <tr>
                <th>報到狀態</th>
                <td>
                  {{ props.OnBoard }}
                </td>
              </tr>
              <tr>
                <th>智財變更註記</th>
                <td>
                  {{ props.IPChangeTag === true ? "是" : "否" }}
                </td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <button type="button" @click="showDetailModal(props)">
              檢視資訊
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                履歷
              </span>
            </a>
            <a @click.prevent="detailCurrentPage = 1">
              <span>
                <eva-icon name="message-circle-outline" fill="#FFF" />
                面談紀錄
              </span>
            </a>
            <a @click.prevent="detailCurrentPage = 2">
              <span>
                <eva-icon name="clipboard-outline" fill="#FFF" />
                任用單
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 1" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">面談紀錄</div>
                    <div class="item"></div>
                  </div>
                  <InterviewRecord
                    :MatchId="MatchId"
                    :IsSupervisor="true"
                  ></InterviewRecord>
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 2" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">任用單</div>
                    <div class="item"></div>
                  </div>
                  <AppointmentRecord :MatchId="MatchId"></AppointmentRecord>
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 公司Logo
import Logo from "@/components/company/Logo.vue";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談紀錄
import InterviewRecord from "@/components/back/CandidateData/InterviewRecord";
// 任用單
import AppointmentRecord from "@/components/back/CandidateData/AppointmentRecord";

export default {
  name: "Progress_AppointResult",

  components: {
    Logo,
    PersonCard,
    CardStyle,
    IdlResume,
    DlResume,
    InterviewRecord,
    AppointmentRecord,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // 查詢條件
      searchCondition: {},
      supervisorOptions: [],
      interviewDateRange: [],

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類
      showInterviewRecord: false, // 面談紀錄

      // 人員卡片列表
      personList: [],

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁
    };
  },

  methods: {
    // 取得 任用結果(依據使用者所屬部門)
    getAppointmentResult() {
      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.supervisor
        .getAppointmentResultPaging(
          {
            ...this.searchCondition,
            interviewDateStart: this.interviewDateRange
              ? this.$common.dateFormatter(this.interviewDateRange[0])
              : null,
            interviewDateEnd: this.interviewDateRange
              ? this.$common.dateFormatter(this.interviewDateRange[1])
              : null,
            Page: this.currentPage,
            PerPage: 9,
          },
          this.$cookies.get("userId")
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.status === 200) {
              if (response.data.Quantity > 0) {
                this.totalPerson = response.data.Quantity;
                this.personList = response.data.Datas;
                this.$store.commit("ScrollTop", false);
              }
            }
          }
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getAppointmentResult();
    },

    // 檢視資訊 Modal
    showDetailModal(person) {
      this.MatchId = person.MatchId;
      this.ResumeId = person.ResumeId;
      this.ResumeType = person.ResumeType;
      this.isShowDetail = true;
    },

    async getData() {
      try {
        // 取得 主管列表
        const backgroundUser =
          await this.$api.backgroundUser.getBackgroundUser();
        this.supervisorOptions = backgroundUser.data.map((user) => {
          return {
            Guid: user.UserId,
            Name: user.Name,
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  watch: {
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  created() {
    this.getAppointmentResult();
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.appoint-result-table {
  td {
    height: 30px !important;
  }
}
</style>
